module.exports = __webpack_public_path__ + "assets/img/video-img.3e6e5e61.png";